import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from './rest.service';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from './loader.service';
import { MatDialogComponent } from '../components/dialog-box/mat-dialog/mat-dialog.component';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { format } from 'date-fns';
import { enGB } from 'date-fns/locale';

import { DatePipe } from '@angular/common';

import { CommonService } from './common.service';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class FormlyApiService {
  masterData: any;
  regex: any;
  masterDataCate: any[] = [];
  firstData: any[] = [];
  isSection: boolean = false;
  validCondition = true;
  isRepeat: boolean = false;
  isNormal: boolean = false;
  wholeData: any;
  valueChanges: boolean = false;
  params: any;
  categoryParams: any
  form = new FormGroup({});
  wholeDataCategory: any;
  fields: FormlyFieldConfig[] = [];
  myFields: any;
  myModel: any = {};
  anymodel: any = {};
  model: any = {};
  formG !: FormGroup;
 
  constructor(private translate: TranslateService, private commonService: CommonService, private restService: RestService, public dialog: MatDialog,
    private loader: LoaderService) { }
  first(data: any, model: any) {
    this.isRepeat = false;
    this.validCondition = true;
    this.firstData = data
    if (this.firstData[0]?.fieldGroup) {
      //grid part
      this.firstData[0].fieldGroup?.forEach((currentfields: any) => {
        if (currentfields.hasOwnProperty('fieldGroup') && currentfields.hasOwnProperty('type')) {
          currentfields.fieldGroup?.forEach((step: any) => {
            // step.fieldGroup.forEach((stepper:any)=>{
            const gridIndex = step?.fieldGroup?.findIndex((a: any) => a?.templateOptions?.isOnloadAPICall && (a?.templateOptions?.categoryID == "" || a?.templateOptions?.categoryID == null || !a.templateOptions?.hasOwnProperty('categoryID')));
            let gridPart = step?.fieldGroup[gridIndex];
            if (gridPart) {
              this.getMasterData(gridPart);
            }
            const gridCateIndex = step?.fieldGroup?.findIndex((a: any) => a?.templateOptions?.isOnloadAPICall && a?.templateOptions?.categoryID != "" && a?.templateOptions?.categoryID != null);
            let gridPartCate = step?.fieldGroup[gridCateIndex];
            if (gridPartCate) {
              this.getMasterDataCate(gridPartCate);
            }
          })

        }
      })

      let isMatchingItemsCalled = false;
      for (const currentfields of this.firstData[0]?.fieldGroup) {
        let matchingItems: any[];
        if (currentfields.hasOwnProperty('templateOptions') && currentfields.hasOwnProperty('fieldGroup') && !currentfields.hasOwnProperty('type')) {
          currentfields.fieldGroup?.forEach((a: any) => {
            if (a.type == 'grid' && a.templateOptions.hasOwnProperty('innerModel')) {
              if (a.templateOptions.label == "Availability details") {
                model[a.key] = a.templateOptions.innerModel.availabilityJson
              }
              else {
                model[a.key] = [
                  a.templateOptions.innerModel
                ]
              }
            }
          })
          currentfields.fieldGroup[0].fieldArray.fieldGroup.forEach((a: any) => {
            if (a.templateOptions?.isOnloadAPICall && (a.templateOptions?.categoryID == "" || a.templateOptions?.categoryID == null || !a.templateOptions?.hasOwnProperty('categoryID'))) {
              this.getMasterData(a);
            }
            else if (a.templateOptions?.isOnloadAPICall && a.templateOptions?.categoryID != "" && a.templateOptions?.categoryID != null) {
              this.getMasterDataCateGrid(a);
            }
          })
         
        }
        if (currentfields.hasOwnProperty('templateOptions') && !currentfields.hasOwnProperty('fieldGroup')) {
          if (!isMatchingItemsCalled) {
            matchingItems = this.firstData[0].fieldGroup
              .filter((a: any) => a.templateOptions?.isOnloadAPICall && (a.templateOptions?.categoryID === "" || a.templateOptions?.categoryID === null || !a.templateOptions?.hasOwnProperty('categoryID')));

            if (matchingItems.length != 0) {
              this.processMatchingItems(matchingItems);
              isMatchingItemsCalled = true;
            }

            const indexCat = this.firstData[0].fieldGroup.findIndex((a: any) => a.templateOptions?.isOnloadAPICall && a.templateOptions?.categoryID != "" && a.templateOptions?.categoryID != null);
            let normalPartCat = this.firstData[0].fieldGroup[indexCat];
            this.processNormalCase(normalPartCat);
            isMatchingItemsCalled = true;
          }
        }
        else if (!this.isSection && !currentfields.hasOwnProperty('templateOptions') && currentfields.hasOwnProperty('fieldGroup')) {
          matchingItems = currentfields.fieldGroup
            .filter((a: any) => a.templateOptions?.isOnloadAPICall && (a.templateOptions?.categoryID === "" || a.templateOptions?.categoryID === null || !a.templateOptions?.hasOwnProperty('categoryID')));

          if (matchingItems.length != 0) {
            this.processMatchingItems(matchingItems);
          }

          const secIndexCat = currentfields.fieldGroup.findIndex((a: any) => a.templateOptions?.isOnloadAPICall && a.templateOptions?.categoryID != "" && a.templateOptions?.categoryID != null);
          let sectionPartCat = currentfields.fieldGroup[secIndexCat];
          this.processNormalCase(sectionPartCat);
        }
        else if (!this.isRepeat && currentfields.type == 'repeat') {
          if (!currentfields.props?.hasOwnProperty('isAddBtn')) {
            currentfields.props = currentfields.props || {};
            currentfields.props.isAddBtn = false; // or set to any desired default value
          }
          currentfields.fieldArray.fieldGroup.forEach((a: any) => {
            if (a.templateOptions?.isOnloadAPICall && (a.templateOptions?.categoryID == "" || a.templateOptions?.categoryID == null || !a.templateOptions?.hasOwnProperty('categoryID'))) {
              this.getMasterData(a);
            }
            else if (a.templateOptions?.isOnloadAPICall && a.templateOptions?.categoryID != "" && a.templateOptions?.categoryID != null) {
              this.getMasterDataCate(a);
            }
          })
        }
        else if (!this.isRepeat && currentfields.hasOwnProperty('templateOptions') && currentfields.hasOwnProperty('fieldGroup') && !currentfields.hasOwnProperty('type')) {
          // const reaIndex = currentfields.fieldArray?.fieldGroup?.findIndex((a: any) => a.templateOptions?.isOnloadAPICall && a.templateOptions?.categoryID == "");
          matchingItems = currentfields.fieldGroup[0].fieldArray.fieldGroup?.filter((a: any) => a.templateOptions?.isOnloadAPICall && (a.templateOptions?.categoryID === "" || a.templateOptions?.categoryID === null || !a.templateOptions?.hasOwnProperty('categoryID')));

          if (matchingItems?.length != 0) {
            this.processMatchingItems(matchingItems);
          }
          const reaIndexCat = currentfields.fieldGroup[0].fieldArray.fieldGroup?.findIndex((a: any) => a.templateOptions?.isOnloadAPICall && a.templateOptions?.categoryID != "" && a.templateOptions?.categoryID != null);
          let repeatPartCat = currentfields.fieldGroup[0].fieldArray.fieldGroup[reaIndexCat];
          if (repeatPartCat) {
            this.getMasterDataCate(repeatPartCat);
            this.isRepeat = true;
          }
          else if (matchingItems == undefined) {
            this.isRepeat = false;
          }
     
        }
        //stepper in section part
        if (currentfields.type == 'stepper') {
          currentfields.fieldGroup.forEach((s: any) => {
            s.fieldGroup.forEach((p: any) => {
              if (p.hasOwnProperty('fieldGroup')) {
                const stepIndex = p?.fieldGroup?.findIndex((a: any) => a.templateOptions?.isOnloadAPICall && (a.templateOptions?.categoryID == "" || a.templateOptions?.categoryID == null) || !a.templateOptions?.hasOwnProperty('categoryID'));
                let stepPart = p?.fieldGroup[stepIndex];
                if (stepPart) {
                  this.getMasterData(stepPart);
                }
                const stepIndexCat = p?.fieldGroup.findIndex((a: any) => a.templateOptions?.isOnloadAPICall && a.templateOptions?.categoryID != "" && a.templateOptions?.categoryID != null);
                let stepPartCat = p?.fieldGroup[stepIndexCat];
                if (stepPartCat) {
                  this.getMasterDataCate(stepPartCat);
                }
              }
            })
          })

        }
      }
    }
  }



  assignValuesToFieldOptions(field: any, data: any): void {
    this.masterData = this.getPropertyValue(data, field.templateOptions.rObjData);
    field.templateOptions.options = this.masterData;
    // console.log("fields", field.templateOptions.options)
  }


  getMasterData(field: any) {
    if (field?.templateOptions?.isOnloadAPICall == true && field?.templateOptions?.apiUrl != "") {
      field.templateOptions['apiUrl']?.replace("%22", "");
      field.templateOptions['apiUrl']?.replace(",", "");
      field.templateOptions['apiUrl']?.replace(/",$/, "");
      if (!field.templateOptions.isParameterNeed) {
        this.params = {}
      }
      else {
      
        const parameter = field.templateOptions.parameter;
        this.params = JSON.parse(parameter);
      }
      let methodName: any;
      if (field?.templateOptions?.baseApiUrlType == 'base' || !field?.templateOptions?.hasOwnProperty('baseApiUrlType') || field?.templateOptions?.baseApiUrlType == null) {
        methodName = 'postData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'uad') {
        methodName = 'postUATData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'product_config') {
        methodName = 'postProductConfigData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'core') {
        methodName = 'postCoreBaseData'
      }
      this.restService[methodName](this.params, field.templateOptions.apiUrl?.trim()).subscribe((data) => {
        if (data.rcode === 200) {
          this.wholeData = data;
          this.assignValuesToFieldOptions(field, this.wholeData);
        
        }
        else {
          this.commonService.handleRcodeError(data)
        }
      },
        (error) => {
          this.commonService.handleStatusError(error);
        }
      );
    }
  }
  getMasterDataCate(field: any) {
    if (field?.templateOptions?.isOnloadAPICall == true && field?.templateOptions?.apiUrl != "") {
      field.templateOptions['apiUrl'].replace("%22", "");
      field.templateOptions['apiUrl'].replace(",", "");
      field.templateOptions['apiUrl'].replace(/",$/, "");
      if (!field.templateOptions.isParameterNeed) {
        this.categoryParams = {}
      }
      else {
     
        const parameter = field.templateOptions.parameter;
        this.categoryParams = JSON.parse(parameter);
      }
      let methodName: any;
      if (field?.templateOptions?.baseApiUrlType == 'base' || !field?.templateOptions?.hasOwnProperty('baseApiUrlType') || field?.templateOptions?.baseApiUrlType == null) {
        methodName = 'postData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'uad') {
        methodName = 'postUATData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'product_config') {
        methodName = 'postProductConfigData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'core') {
        methodName = 'postCoreBaseData'
      }
      this.restService[methodName](this.categoryParams, field.templateOptions.apiUrl.trim()).subscribe((data) => {
        if (data.rcode === 200) {
          this.wholeDataCategory = data;
        }
        else {
          this.commonService.handleRcodeError(data)
        }
      },
        (error) => {
          this.commonService.handleStatusError(error);
        }
      );
    }
  }
  getMasterDataCateGrid(field: any) {
    if (field?.templateOptions?.isOnloadAPICall == true && field?.templateOptions?.apiUrl != "") {
      field.templateOptions['apiUrl'].replace("%22", "");
      field.templateOptions['apiUrl'].replace(",", "");
      field.templateOptions['apiUrl'].replace(/",$/, "");
      if (!field.templateOptions.isParameterNeed) {
        this.categoryParams = {}
      }
      else {
     
        const parameter = field.templateOptions.parameter;
        this.categoryParams = JSON.parse(parameter);
      }
      let methodName: any;
      if (field?.templateOptions?.baseApiUrlType == 'base' || !field?.templateOptions?.hasOwnProperty('baseApiUrlType') || field?.templateOptions?.baseApiUrlType == null) {
        methodName = 'postData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'uad') {
        methodName = 'postUATData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'product_config') {
        methodName = 'postProductConfigData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'core') {
        methodName = 'postCoreBaseData'
      }
      this.restService[methodName](this.categoryParams, field.templateOptions.apiUrl.trim()).subscribe((data) => {
        if (data.rcode === 200) {
          this.wholeDataCategory = data;
          this.masterDataCate = this.getPropertyValue(this.wholeDataCategory, field.templateOptions.rObjData);
          this.filterDropdownData(field)
        }
        else {
          this.commonService.handleRcodeError(data)
        }
      },
        (error) => {
          this.commonService.handleStatusError(error);
        }
      );
    }
  }
  translatePart(currentfields: any) {
    if (currentfields.templateOptions) {
      currentfields.templateOptions.label = this.translate?.instant(currentfields?.templateOptions?.label);
      if (currentfields.templateOptions.required) {
        currentfields.validation.messages.required = this.translate?.instant(currentfields.templateOptions.label) + this.translate?.instant('is_required');
      }
      if (currentfields.templateOptions.hasOwnProperty('pattern') && currentfields.validation?.messages?.pattern != null) {
        currentfields.validation.messages.pattern = this.translate?.instant(currentfields.templateOptions.label) + this.translate?.instant('is_invalid');
      }
      if (currentfields.templateOptions.hasOwnProperty('minLength') && currentfields.validation?.messages?.minLength != null) {
        currentfields.validation.messages.minLength = this.translate?.instant(currentfields.templateOptions.label) + this.translate?.instant('should_have_at_least') + currentfields.templateOptions.minLength + this.translate?.instant('characters');
      }
      if (currentfields.templateOptions.hasOwnProperty('maxLength') && currentfields.validation?.messages?.maxLength != null) {
        currentfields.validation.messages.maxLength = this.translate?.instant(currentfields.templateOptions.label) + this.translate?.instant('should_not_exceed') + currentfields.templateOptions.maxLength + this.translate?.instant('characters');
      }
      if (currentfields.templateOptions.hasOwnProperty('tooltip')) {
        if (!!currentfields.templateOptions.tooltip) {
          currentfields.templateOptions.tooltip = this.translate?.instant(currentfields.templateOptions.tooltip);
        }
      }
      if (!currentfields.wrappers || currentfields.wrappers == null) {
        currentfields.wrappers = ["tooltip-icon"];
      }
      if (currentfields?.templateOptions?.placeholder?.includes('Enter')) {
        currentfields.templateOptions.placeholder = this.translate?.instant('enter') + ' ' + this.translate?.instant(currentfields.templateOptions.label)
      }
      if (currentfields?.templateOptions?.placeholder?.includes('Select')) {
        currentfields.templateOptions.placeholder = this.translate?.instant('select') + ' ' + this.translate?.instant(currentfields.templateOptions.label)
      }
    }
  }
  getdata() {
     this.fields = this.firstData;
    if (this.fields && this.fields[0] && this.fields[0].fieldGroup) {
      setTimeout(() => {
        this.fields[0].fieldGroup?.forEach((currentfields: any) => {
          if (currentfields?.props?.grid) {
            currentfields.fieldGroup[0].fieldArray.fieldGroup?.forEach((grid: any) => {
              
              if (grid && grid.type == "datepicker") {
                this.dateFormat(grid)
              }
            })

          }
          if (currentfields && !currentfields?.props?.grid && currentfields.hasOwnProperty('templateOptions') && currentfields.type != 'stepper' && currentfields.type != 'repeat' && currentfields?.wrappers[0] != 'panel') {
            this.translatePart(currentfields)
            if (currentfields?.expressionProperties && Object.keys(currentfields.expressionProperties).length > 0) {
              currentfields.templateOptions.expression = currentfields.expressionProperties
            }
            if (currentfields?.type === 'datepicker') {
              this.dateFormat(currentfields)
            }
           
            if (currentfields?.templateOptions?.isOnloadAPICall) {
              if (currentfields.templateOptions.categoryID != "" && currentfields.templateOptions.categoryID != null) {
                this.masterDataCate = this.getPropertyValue(this.wholeDataCategory, currentfields.templateOptions.rObjData);
                this.filterDropdownData(currentfields)
              }
             
            }
            if (!currentfields?.templateOptions?.isOnloadAPICall && currentfields?.templateOptions?.hasOwnProperty('isOnloadAPICall')) {

              let val = currentfields?.templateOptions.cascadingParentControl
              let parentField = this.fields[0].fieldGroup.find((a: any) => a.key == val);
              if (parentField) {
                if (parentField?.defaultValue != "" && parentField?.defaultValue != undefined && parentField?.defaultValue != null) {
                  this.hideClass(currentfields, parentField?.defaultValue)
                  this.cascadeApiCallEdit(currentfields, parentField?.defaultValue)
                }
              }
            }

          }
          else if (currentfields?.wrappers[0] == 'panel') {
            currentfields.props.label = this.translate.instant(currentfields?.props?.label);

            currentfields.fieldGroup?.forEach((a: any) => {
              this.translatePart(a)
              if (a?.expressionProperties && Object.keys(a.expressionProperties).length > 0) {
                if (a.hasOwnProperty('templateOptions')) {
                  a.templateOptions.expression = a.expressionProperties
                }
              }
              if (a?.type === 'datepicker') {
                this.dateFormat(a)
              }
              if (a?.type === 'date-time-picker') {
                //this.formatDate(a)
              }
              if (a && a?.templateOptions?.isOnloadAPICall) {
                if (a.templateOptions.categoryID != "" && a.templateOptions.categoryID != null) {
                  this.masterDataCate = this.getPropertyValue(this.wholeDataCategory, a.templateOptions.rObjData);
                  this.filterDropdownData(a)
                }

                
              }
              if (!a?.templateOptions?.isOnloadAPICall && a?.templateOptions?.hasOwnProperty('isOnloadAPICall')) {
            
                let val = a?.templateOptions.cascadingParentControl
                let parentField = currentfields.fieldGroup.find((a: any) => a.key == val);
                if (parentField) {
                  if (parentField?.defaultValue != "" && parentField?.defaultValue != undefined && parentField?.defaultValue != null) {
                    this.hideClass(a, parentField?.defaultValue)
                    this.cascadeApiCallEdit(a, parentField?.defaultValue)
                  }
                }
              }
            });
          }
          else if (currentfields.type == 'stepper') {
            currentfields.fieldGroup.forEach((step: any) => {
              step.fieldGroup.forEach((stepper: any) => {
                if (!stepper.hasOwnProperty('fieldGroup')) {
                  this.translatePart(stepper)
                  if (stepper?.type === 'datepicker') {
                    this.dateFormat(stepper)
                  }
                  if (stepper && stepper?.templateOptions?.isOnloadAPICall) {
                    if (stepper.templateOptions.categoryID != "" && stepper.templateOptions.categoryID != null) {
                      this.masterDataCate = this.getPropertyValue(this.wholeDataCategory, stepper.templateOptions.rObjData);
                      this.filterDropdownData(stepper)
                    }
                    else if (stepper?.templateOptions.categoryID == "" || stepper?.templateOptions.categoryID == null || stepper?.templateOptions.hasOwnProperty('categoryID')) {
                      this.masterData = this.getPropertyValue(this.wholeData, stepper.templateOptions.rObjData);
                      stepper.templateOptions.options = this.masterData;
                    }
                  }
                }
                else if (stepper.hasOwnProperty('fieldGroup')) {
                  stepper.fieldGroup.forEach((steps: any) => {
                    this.translatePart(steps)
                    if (steps?.type === 'datepicker') {
                      this.dateFormat(steps)
                    }
                    if (steps && steps?.templateOptions?.isOnloadAPICall) {
                      if (steps.templateOptions.categoryID != "" && steps.templateOptions.categoryID != null) {
                        this.masterDataCate = this.getPropertyValue(this.wholeDataCategory, steps.templateOptions.rObjData);
                        this.filterDropdownData(steps)
                      }
                      else if (steps?.templateOptions.categoryID == "" || steps?.templateOptions.categoryID == null || steps?.templateOptions.hasOwnProperty('categoryID')) {
                        this.masterData = this.getPropertyValue(this.wholeData, steps.templateOptions.rObjData);
                        steps.templateOptions.options = this.masterData;
                      }
                    }
                  })
                }
              })
            })
          }
          else if (currentfields.type == 'repeat') {

            // Handle repeat fields
            currentfields.props.label = this.translate?.instant(currentfields?.props?.label);
            currentfields.fieldGroup.forEach((faField: any, index: number) => {
              faField.fieldGroup.forEach((b: any) => {
                this.translatePart(b);
                if (b?.expressionProperties && Object.keys(b.expressionProperties).length > 0) {
                  b.hideProp = b.expressionProperties.hide
                  b.expressionProperties.hide = "true"
                }
                if (b?.type === 'datepicker') {
                  this.dateFormat(b)
                }
                if (b && b?.templateOptions?.isOnloadAPICall) {
                  if (b.templateOptions.categoryID != "" && b.templateOptions.categoryID != null) {
                    this.masterDataCate = this.getPropertyValue(this.wholeDataCategory, b.templateOptions.rObjData);
                    this.filterDropdownData(b)
                  }

                 
                }
                if (!b?.templateOptions?.isOnloadAPICall) {
                  let val = b?.templateOptions.cascadingParentControl
                  let parentField = currentfields.fieldArray?.fieldGroup.find((a: any) => a.key == val);
                  if (parentField) {
                    if (parentField?.defaultValue != "" && parentField?.defaultValue != undefined && parentField?.defaultValue != null) {
                      this.hideClass(b, parentField?.defaultValue)
                      this.cascadeApiCallEdit(b, parentField?.defaultValue)
                    }
                  }
                }
              })
            })
          }
        });
      });

      setTimeout(() => { this.loader.hide() }, 500);
    }
    return this.fields

  }
  hideClass(currentField: any, selectedValue: any) {
    if (currentField.templateOptions.hasOwnProperty('expression')) {


      if (currentField?.templateOptions?.expression?.className?.includes("'")) {
        this.regex = /model\.(\w+)\s*!==\s*'([^']+)'/;
      }
      else if (!currentField?.templateOptions?.expression?.className?.includes("'")) {
        this.regex = /model\.(\w+)\s*!==\s*([^'"\s]+)?/;
      }
      let data = currentField.templateOptions?.expression?.className
      let matches = this.regex.exec(data);
      if (matches && matches.length === 3) {
        currentField.hideName = matches[1];
        currentField.hideValue = matches[2];
      }
      if (selectedValue == currentField.hideValue) {
        currentField.className = "col-md-12"


      }
      else {
        currentField.className = "d-none"
      }
    }
  }
  dateChange(type: any, count: any) {
    const dateObj = new Date();
    if (type?.includes('date')) {
      dateObj.setDate(dateObj.getDate() + (type?.includes('forward') ? count : -count));
    }
    else if (type?.includes('month')) {
      dateObj.setMonth(dateObj.getMonth() + (type?.includes('forward') ? count : -count));
    }
    else if (type?.includes('year')) {
      dateObj.setFullYear(dateObj.getFullYear() + (type?.includes('forward') ? count : -count));
    }
    return dateObj;
  }
  dateFormat(currentField: any) {
    if (currentField?.templateOptions?.dateMinType != null) {
      currentField.templateOptions.datepickerOptions.min = this.dateChange(currentField?.templateOptions.dateMinType, parseInt(currentField.templateOptions.countMin))
    }
    if (currentField?.templateOptions?.dateMaxType != null) {
      currentField.templateOptions.datepickerOptions.max = this.dateChange(currentField.templateOptions.dateMaxType, parseInt(currentField.templateOptions.countMax))
    }
  }
  filterDropdownData(field: any) {
    const categoryID = field.templateOptions?.['categoryID'];
    if (categoryID && field.templateOptions?.['isOnloadAPICall']) {
      const filteredData = this.masterDataCate?.filter((item: any) => item.mdCategoryID === categoryID);
      if (field && field.templateOptions && field.templateOptions?.options) {
        field.templateOptions.options = filteredData;
      }
    }
  }
  getPropertyValue(obj: any, propertyPath: string): any {
    if (propertyPath && obj) {
      const properties = propertyPath.split('.');
      for (const prop of properties) {
        if (prop in obj) {
          obj = obj[prop];
        } else {
          return null; // Property not found
        }
      }

      return obj;
    }
  }
  processNormalCase(normalPart: any): void {
    if (normalPart) {
      this.getMasterDataCate(normalPart);
      this.isNormal = true;
    } else {
      this.isNormal = false;
    }
  }

  processRepeatCase(repeatPart: any): void {
    if (repeatPart) {
      this.getMasterData(repeatPart);
      this.isRepeat = true;
    } else {
      this.isRepeat = false;
    }
  }
  processMatchingItems(matchingItems: any[]): void {
    // Check if all items have the same apiUrl
    const sameApiUrl = matchingItems?.every((item, index, array) =>
      index === 0 || (item?.templateOptions?.apiUrl === array[index - 1]?.templateOptions?.apiUrl && item?.templateOptions?.rObj === array[index - 1]?.templateOptions?.rObjData)
    );

    if (sameApiUrl) {
      // Call getMasterData only once
      this.getMasterData(matchingItems[0]);
    } else {
      // If apiUrl is not the same for all items, call getMasterData for each item
      matchingItems?.forEach((item: any) => {
        this.getMasterData(item);
      });
    }
  }

  validations(fields: any, form: FormGroup) {
    this.form = form
    this.fields = fields;
    setTimeout(() => {
      for (const fieldGroup of this.fields) {
        // Handle nested field groups
        fieldGroup.fieldGroup?.forEach((a: any) => {
          if (a.fieldGroup && a.type != 'repeat') {
            a.fieldGroup.forEach((a: any) => {
              this.clearValidation(a)
              if (a?.expressionProperties && Object.keys(a.expressionProperties).length > 0) {
                const className = a.expressionProperties?.className

                // Split the className string by '?'
                const parts = className?.split('?');

                // parts[0] will contain the condition part before '?'
                if (parts) {
                  const conditionPart = parts[0]?.trim();
                  if (conditionPart?.includes("'")) {
                    this.regex = /model\.(\w+)\s*!==\s*'([^']+)'/;
                  }
                  else if (!conditionPart?.includes("'")) {
                    this.regex = /model\.(\w+)\s*!==\s*([^'"\s]+)?/;
                  }

                }



                let data = a.expressionProperties?.className
                let matches = this.regex?.exec(data);
                if (matches && matches.length === 3) {
                  a.hideName = matches[1];
                  a.hideValue = matches[2];
                }

                const changeFieldControl = this.form?.get(a.hideName) as FormControl;

                if (changeFieldControl) {

                  changeFieldControl.valueChanges.subscribe((selectedValue: any) => {
                    if (this.validCondition) {
                      if (selectedValue) {
                        if (selectedValue == a.hideValue) {
                          const fieldControl: any = this.form?.get(a.key) as FormControl;
                          fieldControl.setValue(null);
                          a.defaultValue = null;
                          a.templateOptions?.customControl?.setValue(null)
                          fieldControl.defaultValue = null;
                          if (fieldControl) {
                            if (fieldControl?.isValidation == true) {
                              fieldControl.isValidation = false;
                              fieldControl.addValidators(Validators.required);
                              fieldControl.updateValueAndValidity();
                            }
                          }
                        }
                        else {
                          const fieldNullControl: any = this.form?.get(a.key) as FormControl;
                          fieldNullControl.setValue(null);
                          a.defaultValue = null;
                          fieldNullControl.defaultValue = null;
                          a.templateOptions?.customControl?.setValue(null)
                          if (fieldNullControl) {
                            if (fieldNullControl?.errors?.required) {
                              fieldNullControl.isValidation = true;
                              fieldNullControl.clearValidators();
                              
                              fieldNullControl.updateValueAndValidity();

                            }

                          }
                        }
                      }
                    }
                  });
                }
              }
            })
          }
          else if ((!a.hasOwnProperty('fieldGroup') && a.hasOwnProperty('templateOptions')) || a.type == 'repeat') {
            this.clearValidation(a)
            if (a?.expressionProperties && Object.keys(a.expressionProperties).length > 0) {
              const className = a.expressionProperties?.className

              // Split the className string by '?'
              const parts = className?.split('?');

              // parts[0] will contain the condition part before '?'
              if (parts) {
                const conditionPart = parts[0]?.trim();
                if (conditionPart?.includes("'")) {
                  this.regex = /model\.(\w+)\s*!==\s*'([^']+)'/;
                }
                else if (!conditionPart?.includes("'")) {
                  this.regex = /model\.(\w+)\s*!==\s*([^'"\s]+)?/;
                }

              }



              let data = a.expressionProperties?.className
              let matches = this.regex?.exec(data);
              if (matches && matches.length === 3) {
                a.hideName = matches[1];
                a.hideValue = matches[2];
              }

              const changeFieldControl = this.form?.get(a.hideName) as FormControl;

              if (changeFieldControl) {

                changeFieldControl.valueChanges.subscribe((selectedValue: any) => {
                  if (this.validCondition) {
                    if (selectedValue) {
                      if (selectedValue == a.hideValue) {
                        const fieldControl: any = this.form?.get(a.key) as FormControl;
                        fieldControl.setValue(null);
                        a.defaultValue = null;
                        a.templateOptions?.customControl?.setValue(null)
                        fieldControl.defaultValue = null;
                        if (fieldControl) {
                          if (fieldControl?.isValidation == true) {
                            fieldControl.isValidation = false;
                            fieldControl.addValidators(Validators.required);
                            fieldControl.updateValueAndValidity();
                          }
                        }
                      }
                      else {
                        const fieldNullControl: any = this.form?.get(a.key) as FormControl;
                        fieldNullControl.setValue(null);
                        a.defaultValue = null;
                        fieldNullControl.defaultValue = null;
                        a.templateOptions?.customControl?.setValue(null)
                        if (fieldNullControl) {
                          if (fieldNullControl?.errors?.required) {
                            fieldNullControl.isValidation = true;
                            fieldNullControl.clearValidators();
                          
                            fieldNullControl.updateValueAndValidity();

                          }

                        }
                      }
                    }
                  }
                });
              }
            }
          }
      
        })
      }

    }, 1000);
  }

  clearValidation(a: any) {
    if (a.className == "d-none") {
      const currentNoneData: any = a?.key;
      const currentNoneControl: any = this.form?.get(currentNoneData) as FormControl;
      if (currentNoneControl) {
        currentNoneControl.setValue(null);
        a?.templateOptions?.customControl?.setValue(null);
        a.defaultValue = null;
        currentNoneControl.defaultValue = null;
        if (currentNoneControl?.errors?.required) {
          currentNoneControl.isValidation = true;
          currentNoneControl.clearValidators();
          currentNoneControl.updateValueAndValidity();
        }
      }
    }
    if (a.className == "form-field") {
      const currentFieldData: any = a?.key;
      const currentFieldControl: any = this.form?.get(currentFieldData) as FormControl;
      if (currentFieldControl) {
        if (currentFieldControl?.isValidation == true) {
          currentFieldControl.isValidation = false;
          currentFieldControl.addValidators(Validators.required);
          currentFieldControl.updateValueAndValidity();
        }
      }
    }

  }
  checkTypes(fields: any, form: FormGroup) {
    this.form = form
    this.fields = fields;
    if (this.fields?.[0]?.fieldGroup) {
      this.fields[0].fieldGroup.forEach((currentfields: any) => {
        if (currentfields?.hasOwnProperty('templateOptions') && (!currentfields.hasOwnProperty('fieldGroup') || currentfields.fieldGroup == null)) {
          if (!currentfields?.templateOptions?.isOnloadAPICall && currentfields.templateOptions?.hasOwnProperty('isOnloadAPICall')) {
            this.valueChanges = true;
            this.configureCascadingField(currentfields, this.fields[0].fieldGroup);
          }
          if (currentfields?.templateOptions?.isPrePopulate) {
            this.valueChanges = true;
            this.prePopulateField(currentfields);
          }
          if (currentfields?.type == 'datepicker') {
            this.valueChanges = true;
            this.configureCascadingField(currentfields, this.fields[0].fieldGroup);
          }

        }
        if (!currentfields.hasOwnProperty('type') && currentfields.hasOwnProperty('templateOptions') && currentfields.hasOwnProperty('fieldGroup') && currentfields.templateOptions.label !== "Availability details") {
          currentfields.fieldGroup[0].fieldArray.fieldGroup.forEach((grid: any) => {
            if (grid && grid?.templateOptions.hasOwnProperty('isOnloadAPICall')) {
              if (!grid?.templateOptions.isOnloadAPICall) {
                this.valueChanges = true;
                this.configureCascadingGridFormArrayField(grid, currentfields?.fieldGroup[0]);
              }
            }
            if (grid && grid.type == "datepicker") {
              this.configureCascadingGridFormArrayField(grid, currentfields?.fieldGroup[0]);

            }
          })
        }
        else if (!currentfields.hasOwnProperty('templateOptions') && currentfields.hasOwnProperty('fieldGroup') && !currentfields.hasOwnProperty('type')) {
          currentfields.fieldGroup.forEach((a: any) => {

            if (a && !a.templateOptions?.isOnloadAPICall) {
              this.valueChanges = true;
              this.configureCascadingField(a, currentfields.fieldGroup);
            }
            if (a && a.type == "datepicker") {
              this.valueChanges = true;
              this.configureCascadingField(a, currentfields.fieldGroup);
            }
          });
        }
        else if (currentfields.type == 'stepper') {

          currentfields.fieldGroup.forEach((step: any) => {
            step.fieldGroup.forEach((stepper: any) => {
              if (stepper.hasOwnProperty('fieldGroup')) {
                stepper.fieldGroup.forEach((steps: any) => {
                  if (steps && !steps?.templateOptions?.isOnloadAPICall) {
                    this.valueChanges = true;
                    this.configureCascadingField(steps, stepper.fieldGroup);
                  }
                })
              }
              else if (!stepper.hasOwnProperty('fieldGroup')) {
                if (stepper && !stepper?.templateOptions?.isOnloadAPICall) {
                  this.valueChanges = true;
                  this.configureCascadingField(stepper, step.fieldGroup);
                }
              }
            })
          })
        }
        else if (currentfields?.type == 'repeat') {

          currentfields.fieldArray.fieldGroup.forEach((b: any) => {
            if (b && !b.templateOptions.isOnloadAPICall) {
              this.valueChanges = true;
              this.configureCascadingFormArrayField(b, currentfields);
            }
            if (b && b.type == "datepicker") {
              this.valueChanges = true;
              this.configureCascadingFormArrayField(b, currentfields);
            }
          });
        }


      });
      // this.loader.hide();
    }
  }
  getBoolean() {
    return this.valueChanges
  }
  prePopulateField(field: any) {

    field.hooks = {
      onInit: (currentFields: any) => {
        if (currentFields) {
          const handleField = (currentField: any) => {
            const currentFieldData: any = currentFields?.key;
            const currentFieldControl = this.form?.get(currentFieldData) as FormControl;
            if (currentFieldControl) {
              currentFieldControl.valueChanges.subscribe((selectedValue) => {
                if (this.valueChanges) {
                  this.cascadeApiCall(currentField, selectedValue)
                }
              })
            }
          };
          handleField(currentFields); // Call handleField with the currentFields
        }
      },
    };
  }
  configureCascadingField(field: any, wholeData: any) {


    field.hooks = {
      onInit: (currentFields: any) => {
        if (currentFields) {
          const handleField = (currentField: any) => {
            const findData: any = wholeData?.find((a: any) => a['key'] == currentField.templateOptions['cascadingParentControl']);
            const currentFieldData: any = findData?.key;
            const currentFieldControl = this.form?.get(currentFieldData) as FormControl;

            if (currentFieldControl) {
              currentFieldControl.valueChanges.subscribe((selectedValue) => {
                if (this.valueChanges) {
                  if (selectedValue && selectedValue != "") {
                    if (findData?.templateOptions?.expression?.className !== currentField?.templateOptions?.expression?.className) {
                      this.hideClass(currentField, selectedValue)
                    }
                    this.cascadeApiCall(currentField, selectedValue)
                  }
                }
              })
            }
          
            if (currentField.type === 'datepicker') {
              if (currentField.templateOptions.isDependency) {
                const findDate: any = wholeData?.find((a: any) => a['key'] == currentField.templateOptions['dateParentControl']);
                const currentFieldDate: any = findDate?.key;
                const currentFieldDateControl = this.form?.get(currentFieldDate) as FormControl;
                if (currentFieldDateControl) {
                  this.formatDate(currentFieldDateControl, currentField)
                }
              }
            }

          };
          handleField(currentFields); // Call handleField with the currentFields
        }
      },
    };
  }
  date(type: any, count: any, value: any) {
    const dateObj = new Date(value);
    if (type?.includes('date')) {
      dateObj.setDate(dateObj.getDate() + (type?.includes('forward') ? count : -count));
    }
    else if (type?.includes('month')) {
      dateObj.setMonth(dateObj.getMonth() + (type?.includes('forward') ? count : -count));
      dateObj.setDate(dateObj.getDate() - 1);
    }
    else if (type?.includes('year')) {
      dateObj.setFullYear(dateObj.getFullYear() + (type?.includes('forward') ? count : -count));
      dateObj.setDate(dateObj.getDate() - 1);
    }
    return dateObj;
  }



  formatDate(currentFieldDateControl: any, currentField: any) {
    let isFirstTime = true;  // A flag to track whether it's the first time or not

    currentFieldDateControl.valueChanges.subscribe((selectedValue: any) => {
      currentField.templateOptions.readOnly = false;

      // Check if it's the first time before setting null
      if (!isFirstTime) {
        currentField.formControl.setValue(null);  // Set null after the first time
        currentField?.templateOptions?.customControl?.setValue(null);
      }

      // After the first change, reset the flag
      isFirstTime = false;


      // Handle the dependent date logic
      if (currentField.templateOptions.dateTypeMinDepent !== "" && currentField.templateOptions.dateTypeMinDepent !== null) {
        currentField.templateOptions.datepickerOptions.min = this.date(
          currentField.templateOptions.dateTypeMinDepent,
          parseInt(currentField.templateOptions.countMinDepent),
          selectedValue
        );
      }

      if (currentField.templateOptions.dateTypeMaxDepent !== "" && currentField.templateOptions.dateTypeMaxDepent !== null) {
        currentField.templateOptions.datepickerOptions.max = this.date(
          currentField.templateOptions.dateTypeMaxDepent,
          parseInt(currentField.templateOptions.countMaxDepent),
          selectedValue
        );
      }
    });
  }

  configureCascadingFormArrayField(field: any, wholeData: any) {
    field.hooks = {
      onInit: (currentFields: any) => {
        if (currentFields) {
          const handleField = (currentField: any) => {
            const formSubmissionData = this.fields;
            formSubmissionData.forEach((fieldGroup: any) => {
              if (fieldGroup.fieldGroup) {
                fieldGroup.fieldGroup.forEach((field: any) => {
                  if (field.type === "repeat") {
                    field.fieldGroup.forEach((faField: any, faFieldIndex: number) => {
                      faField.fieldGroup.forEach((fagField: any) => {
                        if (fagField.templateOptions.hasOwnProperty('cascadingParentControl')) {
                          const findData: any = faField.fieldGroup?.find((a: any) => a['key'] == fagField.templateOptions['cascadingParentControl']);
                          const currentArrayFieldData: any = findData?.key;
                          const currentArrayFieldControl = ((this.form?.get(wholeData.key) as FormArray).at(faFieldIndex) as FormArray).get(currentArrayFieldData) as FormControl;
                          if (currentArrayFieldControl) {

                            currentArrayFieldControl.valueChanges.subscribe((selectedValue: any) => {

                              if (this.valueChanges) {
                                if (selectedValue && selectedValue != "") {
                                  this.cascadeApiCall(fagField, selectedValue)
                                }
                              }
                            })
                          }
                        }
                        if (fagField.type === 'datepicker') {
                          if (fagField.templateOptions.isDependency) {
                            let findDate: any = faField.fieldGroup?.find((a: any) => a['key'] == fagField.templateOptions['dateParentControl']);
                            let currentFieldDate: any = findDate?.key;
                            let currentArrayFieldDateControl = ((this.form?.get(wholeData.key) as FormArray).at(faFieldIndex) as FormArray).get(currentFieldDate) as FormControl;
                            if (currentArrayFieldDateControl) {
                              this.formatDate(currentArrayFieldDateControl, fagField)
                            }
                          }
                        }
                        if (fagField.hasOwnProperty('hideProp')) {
                          
                          let conditionsArray = this.parseConditions(fagField?.hideProp);
                          conditionsArray.forEach((data: any) => {
                            const findHide: any = faField.fieldGroup?.find((a: any) => a['key'] == data.controlName);
                            const currentArrayFieldHide: any = findHide?.key;
                            // console.log(currentArrayFieldHide)
                            const currentArrayFieldHideControl = ((this.form?.get(wholeData.key) as FormArray).at(faFieldIndex) as FormArray).get(currentArrayFieldHide) as FormControl;

                            if (currentArrayFieldHideControl) {
                              currentArrayFieldHideControl.valueChanges.subscribe((selectedValue: any) => {
                                // Convert selectedValue to a string for comparison
                                let stringValue = selectedValue.toString();

                                // Find if the selectedValue exists in conditionsArray
                                let findVal = conditionsArray.find((a: any) => a.value === stringValue);
                                if (!fagField.hide && findVal) {
                                  fagField.hide = false;
                                }
                                else if (!fagField.hide && findVal == undefined) {
                                  fagField.hide = false;
                                }
                                else if (fagField.hide && findVal) {
                                  fagField.hide = false;
                                }
                                else {
                                  fagField.hide = true;
                                }
                              });
                            }
                          })

                        }
                      })
                    })
                  }
                })
              }

            })
          };

          handleField(currentFields);
        }
      },
    };
  }
  configureCascadingGridFormArrayField(field: any, wholeData: any) {
    field.hooks = {
      onInit: (currentFields: any) => {
        if (currentFields) {
          const handleField = (currentField: any) => {
            if (this.fields[0].fieldGroup) {
              this.fields[0].fieldGroup.forEach((a: any, i: any) => {
                if (a.templateOptions.label !== "Availability details") {
                  if (a?.fieldGroup?.[0]?.fieldGroup) {
                    a.fieldGroup[0]?.fieldGroup.forEach((faField: any, faFieldIndex: number) => {
                      if (faField.fieldGroup) {
                        faField.fieldGroup.forEach((grid: any) => {
                          grid.stop = false;
                          if (grid.templateOptions.hasOwnProperty('cascadingParentControl')) {
                            const findGridData: any = faField.fieldGroup?.find((a: any) => a['key'] == grid.templateOptions['cascadingParentControl']);
                            const currentArrayGridFieldData: any = findGridData?.key;
                            const currentArrayGridFieldControl = ((this.form?.get(wholeData.key) as FormArray).at(faFieldIndex) as FormArray).get(currentArrayGridFieldData) as FormControl;
                            if (currentArrayGridFieldControl) {
                              currentArrayGridFieldControl.valueChanges.subscribe((selectedValue: any) => {

                                // if (!grid.stop) {
                                if (this.valueChanges) {
                                  if (selectedValue && selectedValue != "") {
                                    this.cascadeApiCall(grid, selectedValue)
                                  }
                                }
                                // }
                                grid.stop = true;
                              })
                            }
                          }
                          if (grid.type === 'datepicker') {
                            if (grid.templateOptions.isDependency) {
                              let findDate: any = faField.fieldGroup?.find((a: any) => a['key'] == grid.templateOptions['dateParentControl']);
                              let currentFieldDate: any = findDate?.key;
                              let currentArrayFieldDateControl = ((this.form?.get(wholeData.key) as FormArray).at(faFieldIndex) as FormArray).get(currentFieldDate) as FormControl;
                              if (currentArrayFieldDateControl) {
                                this.formatDate(currentArrayFieldDateControl, grid)
                              }
                            }
                          }
                        })
                      }
                    })
                  }

                }
              })
            }
          };

          handleField(currentFields);
        }
      },
    };
  }
  parseConditions(data) {
    // Split the condition part from the rest
    let conditionsPart = data.split('?')[0];

    // Split into individual conditions
    let rawConditions = conditionsPart.split('&&').map(cond => cond.trim());

    // Map to desired format
    let conditions = rawConditions.map(cond => {
      // Remove "model." and split by "!=="
      let [controlName, value] = cond.replace('model.', '').split('!== ').map(part => part.trim());

      // Handle boolean values
      // value = value === 'true' ? true : (value === 'false' ? false : value);
      value = value === "true" || value === "false" ? value : value?.slice(1, -1);
      // Return condition object
      return { controlName, value };
    });

    // Filter out invalid conditions if necessary
    return conditions.filter(cond => cond.controlName && cond.value !== undefined);
  }
  cascadeApiCall(field: any, value: any) {
    if (field.className !== 'd-none') {
      if (field?.templateOptions?.hasOwnProperty('isMultipleParameter')) {
        if (field.templateOptions.isMultipleParameter) {
          const parameter = field.templateOptions.cascadingParameter;
          this.params = JSON.parse(parameter);
          if (field?.templateOptions?.inputParameter != "") {
            this.params[field.templateOptions.inputParameter] = value
          }
        }
        else {
          const inputParameterKey = Object.keys(field.templateOptions).find(key =>
            key.toLowerCase() === 'inputparameter'
          );

          if (inputParameterKey) {
            this.params = {
              [field.templateOptions[inputParameterKey]]: value
            }
          }
        }
      }

      else {
        const inputParameterKey = Object.keys(field.templateOptions).find(key =>
          key.toLowerCase() === 'inputparameter'
        );

        if (inputParameterKey) {
          this.params = {
            [field.templateOptions[inputParameterKey]]: value
          }
        }
      }
      this.loader.show();
      field.templateOptions['apiUrl']?.replace("%22", "");
      field.templateOptions['apiUrl']?.replace(",", "");
      let methodName: any;
      if (field?.templateOptions?.baseApiUrlType == 'base' || !field?.templateOptions?.hasOwnProperty('baseApiUrlType') || field?.templateOptions?.baseApiUrlType == null) {
        methodName = 'postData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'uad') {
        methodName = 'postUATData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'product_config') {
        methodName = 'postProductConfigData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'core') {
        methodName = 'postCoreBaseData'
      }
      this.restService[methodName](this.params, field.templateOptions['apiUrl'].trim()).subscribe(
        (data) => {
          if (data.rcode === 200) {
            let cascadeData: any = this.getPropertyValue(data, field.templateOptions['rObjData']);
            field.templateOptions.options = cascadeData;
            field.templateOptions.placeholder = "Select " + field.templateOptions.label;
            // field.className="";
            field.formControl.setValue(null);
            field.defaultValue = null
            field?.templateOptions?.customControl?.setValue(null);
            this.loader.hide();
            //  setTimeout(() => {
            //   this.loader.hide();
            //  }, 3000);
          } else {
            this.commonService.handleRcodeError(data)
          }
        },
        (error) => {
          this.commonService.handleStatusError(error);
        }
      );
    }
  }
  prePopulateApiCall(field: any, value: any) {
    if (field.className !== 'd-none') {
      const inputParameterKey = Object.keys(field.templateOptions).find(key =>
        key.toLowerCase() === 'inputparameter'
      );

      if (inputParameterKey) {
        this.params = {
          [field.templateOptions[inputParameterKey]]: value
        }
      }

      this.loader.show();
      field.templateOptions['apiUrl']?.replace("%22", "");
      field.templateOptions['apiUrl']?.replace(",", "");
      let methodName: any;
      if (field?.templateOptions?.baseApiUrlType == 'base' || !field?.templateOptions?.hasOwnProperty('baseApiUrlType') || field?.templateOptions?.baseApiUrlType == null) {
        methodName = 'postData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'uad') {
        methodName = 'postUATData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'product_config') {
        methodName = 'postProductConfigData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'core') {
        methodName = 'postCoreBaseData'
      }
      this.restService[methodName](this.params, field.templateOptions['apiUrl'].trim()).subscribe(
        (data) => {
          if (data.rcode === 200) {
            let cascadeData: any = this.getPropertyValue(data, field.templateOptions['rObjData']);

          } else {
            this.commonService.handleRcodeError(data)
          }
        },
        (error) => {
          this.commonService.handleStatusError(error);
        }
      );
    }
  }
  
  cascadeApiCallEdit(field: any, value: any) {
    if (field.className !== 'd-none') {
      if (field?.templateOptions?.hasOwnProperty('isMultipleParameter')) {
        if (field.templateOptions.isMultipleParameter) {
          const parameter = field.templateOptions.cascadingParameter;
          this.params = JSON.parse(parameter);
          if (field?.templateOptions?.inputParameter != "") {
            this.params[field.templateOptions.inputParameter] = value
          }
        }
        else {
          const inputParameterKey = Object.keys(field.templateOptions).find(key =>
            key.toLowerCase() === 'inputparameter'
          );

          if (inputParameterKey) {
            this.params = {
              [field.templateOptions[inputParameterKey]]: value
            }
          }
        }
      }

      else {
        const inputParameterKey = Object.keys(field.templateOptions).find(key =>
          key.toLowerCase() === 'inputparameter'
        );

        if (inputParameterKey) {
          this.params = {
            [field.templateOptions[inputParameterKey]]: value
          }
        }
      }
      // this.loader.show();
      field.templateOptions['apiUrl']?.replace("%22", "");
      field.templateOptions['apiUrl']?.replace(",", "");
      let methodName: any;
      if (field?.templateOptions?.baseApiUrlType == 'base' || !field?.templateOptions?.hasOwnProperty('baseApiUrlType') || field?.templateOptions?.baseApiUrlType == null) {
        methodName = 'postData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'uad') {
        methodName = 'postUATData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'product_config') {
        methodName = 'postProductConfigData'
      }
      else if (field?.templateOptions?.baseApiUrlType == 'core') {
        methodName = 'postCoreBaseData'
      }
      this.restService[methodName](this.params, field.templateOptions['apiUrl']?.trim()).subscribe(
        (data) => {
          if (data.rcode === 200) {
            let cascadeData: any = this.getPropertyValue(data, field.templateOptions['rObjData']);
            field.templateOptions.options = cascadeData;
         
            field.formControl.valueChanges.subscribe((a: any) => {
              if (a?.length == 0 || a == null || a == undefined) {

                field.templateOptions.placeholder = "Select " + field.templateOptions.label;
                field.className = ""
              }

            })

            if (field.defaultValue == null || field.defaultValue == undefined || field.defaultValue.length == 0) {
              field.templateOptions.placeholder = "Select " + field.templateOptions.label;
              field.className = ""
            }
            if (Array.isArray(field.defaultValue) && field.defaultValue.length > 0) {
              field.className = 'apply-black-placeholder';
              let filteredArray = field.templateOptions.options.filter((item) => field.defaultValue.includes(item[field.templateOptions.valueProp]));
              let titles = filteredArray.map((item) => item[field.templateOptions.labelProp]);
              let output = titles.join(", ");
              field.templateOptions.placeholder = output;
            }
            else if ((field.defaultValue != null || field.defaultValue != undefined) && field.defaultValue.length > 0) {
              let findData = field?.templateOptions?.options?.find((a: any) => a[field.templateOptions.valueProp] == field.defaultValue);
              field.templateOptions.placeholder = findData[field.templateOptions.labelProp];
              field.className = 'apply-black-placeholder';

            }
            // this.loader.hide();
            setTimeout(() => {
              this.loader.hide();
            });
          } else {
            this.commonService.handleRcodeError(data)
          }
        },
        (error) => {
          this.commonService.handleStatusError(error);
        }
      );
    }
  }
  default(field: any) {
    if (field.type == 'checkbox') {
      field.defaultValue = false;
      field.formControl.patchValue(false);
    }
  }
 
  setValueNull(obj: any) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop) && obj[prop] === '' || obj[prop] === 'NaN') {
        obj[prop] = null;
      }
    }
    return obj
  }
  valueChangesFalse() {
    this.valueChanges = false
  }
  valueChangesTrue() {
    this.valueChanges = true
  }

  viewFormArray(field: any): any {
    let matchingLabel = field;
    let key = matchingLabel.key;
    let labelValue;
    if (matchingLabel?.props) {
      labelValue = matchingLabel ? matchingLabel.props.label : key.charAt(0).toUpperCase() + key.slice(1);
    } else if (matchingLabel?.templateOptions) {
      labelValue = matchingLabel ? matchingLabel.templateOptions.label : key.charAt(0).toUpperCase() + key.slice(1);
    } else {
      labelValue = key.charAt(0).toUpperCase() + key.slice(1);
    }
    let defaultValue;
    let value = matchingLabel.formControl.value;
    if (value === false) {
      defaultValue = 'No';
    } else if (value === true) {
      defaultValue = 'Yes';
    } else {
      defaultValue = value || '-';
    }
    if (matchingLabel?.type == 'datepicker' || matchingLabel?.type == 'date') {

      const fieldValue = matchingLabel.formControl.value;
      if (fieldValue) {
        const dateObject = moment(fieldValue);
        defaultValue = dateObject.format('DD-MMM-YYYY');
      }
    }
    if (matchingLabel?.type == 'date-time-picker') {

      const fieldValue = matchingLabel.formControl.value;
      defaultValue = this.convertDateFormat(fieldValue);
    }
    if (matchingLabel?.type != 'repeat') {
      let templateOptions: any = {
        label: labelValue,
        disabled: true,
      }
      if (matchingLabel?.type == 'view-upload-file') {
        templateOptions['files'] = matchingLabel.templateOptions.files
      }
      return {
        key,
        defaultValue,
        type: matchingLabel?.type == 'view-upload-file' ? matchingLabel?.type : 'input',
        templateOptions: templateOptions,
        wrappers: ['tooltip-icon'],
        className: "col-md-12",
      };
    } else {
      // Handle the case when type is 'repeat'
      // For example:
      return null
    }
  }

  convertFormFields(filteredModel: any, field: any, myModel: any, customModel?: any): any {
    return field
      .filter((a: any) => a.key !== "submitApiUrl") // Filter out objects with key "submitApiUrl"
      .map((a: any, index: any) => {
        if (!a.hasOwnProperty('fieldGroup') && a.hasOwnProperty('templateOptions')) {
          return this.viewFormArray(a);
        }
        if (a.fieldGroup && a.type != 'repeat') {
          return {
            fieldGroupClassName: "sections row",
            props: {
              label: a?.props?.label,
            },
            wrappers: ['panel'],
            fieldGroup: a.fieldGroup.map((nestedNormal: any) => {
              return this.viewFormArray(nestedNormal); // Return the result of viewMap
            }),
          };
        } else if (a.fieldGroup && a.type == 'repeat') {
          let fieldFormArray = a.fieldArray;
          let fieldGroups = a.fieldGroup.map((fieldGroupInArray: any, index: number) => {
            return {
              fieldGroup: fieldGroupInArray.fieldGroup.map((item: any) => {
                return this.viewFormArray(item); // Collect the return values
              }),
            };
          });
          fieldFormArray.fieldGroup = fieldGroups;
          return {
            key: a.key,
            defaultValue: '',
            type: 'repeat',
            isView: true,
            fieldArray: fieldFormArray,
            wrappers: ['tooltip-icon'],
            className: "col-md-12",
          };
        } else {
          return null; // Return null for unwanted objects
        }
      })
      .filter((item: any) => item !== null); // Filter out the null objects
  }

  filterDropdownDataview(field: any) {
  
    const label = field.props?.labelProp ?? 'label';
    const valueProp = field.props?.valueProp ?? 'value';
    const options = field.props?.options;
    const value = field.formControl.value
    if (field.props?.isAmount) {
      // const key = field.key;
      const value = field.formControl.value;
      // Check if the value in the model is a valid number
      if (!isNaN(Number(value)) && field.formControl.value != null) {
        // Format the number based on the user's locale
        const formattedAmount = new Intl.NumberFormat(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(parseFloat(value));
        // Update the value in the model
        field.formControl.setValue(formattedAmount);
      }

    }

    if (field.formControl.value && options && options.length >= 2 && !field.props.multiple) {
      const filter = options.find((item: any) => Object.values(item).includes(value));
      let val
      if (filter) {
        val = filter[label];
        this.valueChanges = false;
        this.validCondition = false;
        this.getBoolean();
        field.formControl.setValue(val);
      }
    } else if (field.formControl.value && options && options.length === 1 && !field.props.multiple) {
      let val = options?.map((obj: any) => obj[label]) || [];
      this.valueChanges = false;
      this.validCondition = false;
      this.getBoolean();
      field.formControl.setValue(val ? val[0] : null)
    }
    if (field.formControl.value && field.props.multiple) {
      if (field.formControl.value.length > 0) {
        let matchingLabels = [];
        options.forEach(item => {
          if (field.formControl.value.includes(item[valueProp])) {
            matchingLabels.push(item[label]);
          }
        });
        this.valueChanges = false;
        this.validCondition = false;
        this.getBoolean();
        field.formControl.setValue(matchingLabels.join(', '))
      }
      else {
        this.valueChanges = false;
        this.validCondition = false;
        this.getBoolean();
        field.formControl.setValue('-')
      }
    }
 
    if (field.formControl.value === 'true' || field.formControl.value === 'false') {
      let booleanA = JSON.parse(field.formControl.value.toLowerCase());
      this.valueChanges = false;
      this.validCondition = false;
      this.getBoolean();
      field.formControl.setValue(booleanA)
      return field.formControl.value
    }
  
  }
  typeChange(currentField: any) {

    if (currentField.type == 'date-time-picker') {
      const fieldName = currentField.key; // Assuming key represents the property name in model
      const fieldValue = currentField.formControl.value
      currentField.formControl.setValue(this.convertDateFormat(fieldValue));

    }
    let fileWrapper = currentField.wrappers?.find((item: string) => item == 'multi-file-upload')
    if (fileWrapper) {
      currentField.type = 'view-upload-file',
        currentField.templateOptions.files = [];
      if (!!currentField.formControl.value) {
        let uploadedFiles: any[] = currentField.formControl.value.attachmentID;
        if (uploadedFiles?.length > 0) {
          uploadedFiles.forEach(file => {
            currentField.templateOptions.files.push({
              "fileName": file.fileName,
              "href": file.uploadedURL
            })
          })
        }
      }
    }
  }
 
  convertToViewJSON(field: any, model: any, myFields: any, form: any, myModel: any, anymodel: any) {
    this.myFields = myFields;
    this.formG = form;
    this.myModel = myModel;
    this.anymodel = anymodel;
    this.model = model;
    field.forEach((a: any) => {
      if (!a.hasOwnProperty('fieldGroup') && a.hasOwnProperty('templateOptions')) {
        this.typeChange(a);
        this.filterDropdownDataview(a);
      }
      if (a.fieldGroup && a.type != 'repeat') {
        a.fieldGroup.forEach((b: any, index: any) => {
          this.typeChange(b);
          this.filterDropdownDataview(b)
        })
      }
      if (a.fieldGroup && a.type == 'repeat') {

        let fieldGroups = a.fieldGroup;
        fieldGroups.forEach((fieldGroupInArray: any, index: number) => {
           fieldGroupInArray.fieldGroup.forEach((c: any) => {
            this.typeChange(c);
            this.filterDropdownDataview(c)
          })
        })
      }


    });
    this.myFields = field;

    this.myModel = { ...this.model, ...this.anymodel }
    return { myModel: this.myModel, myFields: this.myFields, form: this.formG, model: this.model, anymodel: this.anymodel };
  }
  convertDateFormat(inputDateString: string): string {
      const d = new Date(inputDateString);
    const inputDate = new Date(d.getTime() - (d.getTimezoneOffset() * 60000));
    // Extract the date and time components
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-indexed
    const day = inputDate.getDate().toString().padStart(2, '0');
    const hours = inputDate.getHours().toString().padStart(2, '0');
    const minutes = inputDate.getMinutes().toString().padStart(2, '0');
    const seconds = inputDate.getSeconds().toString().padStart(2, '0');

    // Create the desired formatted string
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  }

  formSubmissionData(formSubmissionData: any, formValue) {

    formSubmissionData.forEach((a: any) => {

      if ((!a.hasOwnProperty('fieldGroup') && a.hasOwnProperty('templateOptions')) || (a.fieldGroup && a.type == 'repeat')) {
        this.fieldsConversation(a, formValue)
      }
      if (a.fieldGroup && a.type != 'repeat') {
        a.fieldGroup.forEach((b: any) => {
          this.fieldsConversation(b, formValue)
        })

      }
      if (a.hasOwnProperty('templateOptions') && a.templateOptions.grid) {
        // a.fieldGroup.forEach((b:any)=>{
        this.fieldsAggridConversation(a, formValue)
        // })
      }

    });
    delete formValue.submitApiUrl;
    return formValue;
  }
  fieldsAggridConversation(field: any, newFormValue: any) {
    let agKey = field.fieldGroup[0].key
    field.fieldGroup[0].fieldGroup.forEach((faField: any, faFieldIndex: number) => {
      faField.fieldGroup.forEach((fagField: any) => {
        if (fagField.type === 'select' && !(fagField?.props.hasOwnProperty('multiple') && fagField.props.multiple)) {
          const key = fagField.key;
          let labelProp = fagField.props.labelProp ?? "label";
          const extractedKey = key.replace(/(ID|MDID|id)\b$/, '');
          if (newFormValue[agKey][faFieldIndex][key] != undefined && newFormValue[agKey][faFieldIndex][key] != null && newFormValue[agKey][faFieldIndex][key] != "") {
            const selectedOptions = fagField.props.options.find((option: any) => Object.values(option).includes(newFormValue[agKey][faFieldIndex][key]));
            const labelValues = selectedOptions ? selectedOptions[labelProp] : '';
            newFormValue[agKey][faFieldIndex][extractedKey] = labelValues;
          }
          else {
            newFormValue[agKey][faFieldIndex][extractedKey] = null;
            newFormValue[agKey][faFieldIndex][key] = null;
          }

        }
        else if (fagField.type === 'select' && (fagField?.props.hasOwnProperty('multiple') && fagField.props.multiple)) {
          const key = fagField.key;
          let labelProp = fagField.props.labelProp ?? 'label';
          let selectedValues = newFormValue[agKey][faFieldIndex][key];
          let valProp = fagField.props.valueProp ?? 'value';
          const filteredProducts = fagField?.props.options
            .filter((product: any) => selectedValues?.includes(product[valProp]))
            .map((product: any) => ({ id: product[valProp], text: product[labelProp] }));
          newFormValue[agKey][faFieldIndex][key] = filteredProducts || [];
        }
        else if (field.type === 'datepicker') {
          const key = fagField.key;
          const extractedKey = fagField.key + "FormattedDate"
          const fieldValue = fagField.formControl.value;
          if (fieldValue) {
            const dateObject = moment(fieldValue);
            newFormValue[agKey][faFieldIndex][extractedKey] = dateObject.format('DD-MMM-YYYY');
          }
          else {
            newFormValue[agKey][faFieldIndex][extractedKey] = null;
            newFormValue[agKey][faFieldIndex][key] = fagField.formControl.value
          }
        }
        else if (fagField.type === 'radio') {
          let key = fagField.key;
          let val = newFormValue[field.key][faFieldIndex][key];
          if (typeof val === 'string') {
            if (val.toLowerCase() === 'true' || val.toLowerCase() === 'false') {
              let booleanA = JSON.parse(val.toLowerCase());
              newFormValue[agKey][faFieldIndex][key] = booleanA;
            }
            else {
              const key = fagField.key;
              let labelProp = fagField.props.labelProp ?? 'label';
              const extractedKey = key.replace(/(ID|MDI|id)\b$/, '');
              // let model = this.model;
              if (fagField.formControl.value != undefined && fagField.formControl.value != null && fagField.formControl.value != "") {
                const selectedOptions = fagField.templateOptions.options.find((option: any) => Object.values(option).includes(fagField.formControl.value));
                const labelValues = selectedOptions ? selectedOptions[labelProp] : '';
                newFormValue[agKey][faFieldIndex][extractedKey] = labelValues;
              }
              else {
                newFormValue[agKey][faFieldIndex][extractedKey] = null;
                newFormValue[agKey][faFieldIndex][key] = null;
              }
            }
          }
          if (val == undefined) {
            const key = fagField.key;
            const extractedKey = key.replace(/(ID|MDID|id)\b$/, '');
            newFormValue[agKey][faFieldIndex][extractedKey] = null;
            newFormValue[agKey][faFieldIndex][key] = null;
          }
        }
        else {
          const key = fagField.key;
          if (field.formControl.value == undefined) {
            newFormValue[key] = null
          }
          else if (field.formControl.value == "") {
            newFormValue[key] = null
          }
          else if (field.formControl.value == null) {
            newFormValue[key] = null
          }
        }
      });
     
    })
  }
  fieldsConversation(field: any, newFormValue: any) {
 
    if (field.type === 'select' && !field.props.multiple) {
      const key = field.key;
      let labelProp = field.props.labelProp ?? "label";
      const extractedKey = key.replace(/(ID|MDID|id)\b$/, '');
      // let model = this.model;
      if (field.formControl.value != undefined && field.formControl.value != null && field.formControl.value != "") {
        const selectedOptions = field.templateOptions.options?.find((option: any) => Object.values(option).includes(field.formControl.value));
        // const labelValues = selectedOptions ? selectedOptions[labelProp] : '';
        const labelValues = selectedOptions ? selectedOptions[labelProp] : null;
        newFormValue[extractedKey] = labelValues;
      }
      else {
        newFormValue[key] = null
        newFormValue[extractedKey] = null;
      }
    }
    else if (field.type === 'select' && field.props.multiple) {
      let labelProp = field.props.labelProp ?? "label";
      let selectedValues = newFormValue[field.key];
      let valProp = field.props.valueProp ?? "value";
      const filteredProducts = field.props.options
        .filter((product: any) => selectedValues?.includes(product[valProp]))
        .map((product: any) => ({ id: product[valProp], text: product[labelProp] }));
      newFormValue[field.key] = filteredProducts || [];
    }
    else if (field.type === 'datepicker') {
      const key = field.key;
      const extractedKey = field.key + "FormattedDate"
      // const fieldValue = this.convertDateFormat(field.formControl.value);
      const fieldValue = field.formControl.value ? this.convertDateFormat(field.formControl.value) : field.formControl.value;

      if (fieldValue) {
        const dateObject = moment(fieldValue);
        newFormValue[extractedKey] = dateObject.format('DD-MMM-YYYY');
        newFormValue[key] = fieldValue;
      }
      else {
        newFormValue[extractedKey] = null;
        newFormValue[key] = null
      }
    }
    else if (field.type === "repeat") {
      //this.default(field)
      field.fieldGroup.forEach((faField: any, faFieldIndex: number) => {
        faField.fieldGroup.forEach((fagField: any) => {
          if (fagField.type === 'select' && !(fagField?.props.hasOwnProperty('multiple') && fagField.props.multiple)) {
            const key = fagField.key;
            let labelProp = fagField.props.labelProp ?? "label";
            const extractedKey = key.replace(/(ID|MDID|id)\b$/, '');
            if (newFormValue[field.key][faFieldIndex][key] != undefined && newFormValue[field.key][faFieldIndex][key] != null && newFormValue[field.key][faFieldIndex][key] != "") {
              const selectedOptions = fagField.props.options.find((option: any) => Object.values(option).includes(newFormValue[field.key][faFieldIndex][key]));
              const labelValues = selectedOptions ? selectedOptions[labelProp] : '';
              newFormValue[field.key][faFieldIndex][extractedKey] = labelValues;
            }
            else {
              newFormValue[field.key][faFieldIndex][extractedKey] = null;
              newFormValue[field.key][faFieldIndex][key] = null;
            }

          }
          else if (fagField.type === 'select' && (fagField?.props.hasOwnProperty('multiple') && fagField.props.multiple)) {
            const key = fagField.key;
            let labelProp = fagField.props.labelProp ?? 'label';
            let selectedValues = newFormValue[field.key][faFieldIndex][key];
            let valProp = fagField.props.valueProp ?? 'value';
            const filteredProducts = fagField?.props.options
              .filter((product: any) => selectedValues?.includes(product[valProp]))
              .map((product: any) => ({ id: product[valProp], text: product[labelProp] }));
            newFormValue[field.key][faFieldIndex][key] = filteredProducts || [];
          }
          else if (field.type === 'datepicker') {
            const key = fagField.key;
            const extractedKey = fagField.key + "FormattedDate"
            const fieldValue = fagField.formControl.value;
            if (fieldValue) {
              const dateObject = moment(fieldValue);
              newFormValue[field.key][faFieldIndex][extractedKey] = dateObject.format('DD-MMM-YYYY');
            }
            else {
              newFormValue[field.key][faFieldIndex][extractedKey] = null;
              newFormValue[field.key][faFieldIndex][key] = fagField.formControl.value
            }
          }
          else if (fagField.type === 'radio') {
            let key = fagField.key;
            let val = newFormValue[field.key][faFieldIndex][key];
            if (typeof val === 'string') {
              if (val.toLowerCase() === 'true' || val.toLowerCase() === 'false') {
                let booleanA = JSON.parse(val.toLowerCase());
                newFormValue[field.key][faFieldIndex][key] = booleanA;
              }
              else {
                const key = fagField.key;
                let labelProp = fagField.props.labelProp ?? 'label';
                const extractedKey = key.replace(/(ID|MDI|id)\b$/, '');
                // let model = this.model;
                if (fagField.formControl.value != undefined && fagField.formControl.value != null && fagField.formControl.value != "") {
                  const selectedOptions = fagField.templateOptions.options.find((option: any) => Object.values(option).includes(fagField.formControl.value));
                  const labelValues = selectedOptions ? selectedOptions[labelProp] : '';
                  newFormValue[field.key][faFieldIndex][extractedKey] = labelValues;
                }
                else {
                  newFormValue[field.key][faFieldIndex][extractedKey] = null;
                  newFormValue[field.key][faFieldIndex][key] = null;
                }
              }
            }
            if (val == undefined) {
              const key = fagField.key;
              const extractedKey = key.replace(/(ID|MDID|id)\b$/, '');
              newFormValue[field.key][faFieldIndex][extractedKey] = null;
              newFormValue[field.key][faFieldIndex][key] = null;
            }
          }
          else {
            const key = fagField.key;
            if (field.formControl.value == undefined) {
              newFormValue[key] = null
            }
            else if (field.formControl.value == "") {
              newFormValue[key] = null
            }
            else if (field.formControl.value == null) {
              newFormValue[key] = null
            }
          }
        });
  
      })
    }
    else if (field.type === 'radio') {
      let key = field.key;
      let val = newFormValue[key];
      if (typeof val === 'string') {
        if (val.toLowerCase() === 'true' || val.toLowerCase() === 'false') {
          let booleanA = JSON.parse(val.toLowerCase());
          newFormValue[key] = booleanA;
        }
        else {
          const key = field.key;
          let labelProp = field.props.labelProp ?? 'label';
          const extractedKey = key.replace(/(ID|MDID|id)\b$/, '');
          // let model = this.model;
          if (field.formControl.value != undefined && field.formControl.value != null && field.formControl.value != "") {
            const selectedOptions = field.templateOptions.options.find((option: any) => Object.values(option).includes(field.formControl.value));
            const labelValues = selectedOptions ? selectedOptions[labelProp] : '';
            newFormValue[extractedKey] = labelValues;
          }
          else {
            newFormValue[key] = null
            newFormValue[extractedKey] = null;
          }
        }
      }
      if (val == undefined) {
        const key = field.key;
        const extractedKey = key.replace(/(ID|MDID|id)\b$/, '');
        newFormValue[key] = null
        newFormValue[extractedKey] = null;
      }
    }
    else if (field.type === 'checkbox') {
      let key = field.key;
      if (field.formControl.value == undefined) {
        newFormValue[key] = false;
      }
      else {
        newFormValue[key] = field.formControl.value;
      }
    }
    else {
      const key = field.key;
      if (field.formControl.value == undefined) {
        newFormValue[key] = null
      }
      else if (field.formControl.value == "") {
        newFormValue[key] = null
      }
      else if (field.formControl.value == null) {
        newFormValue[key] = null
      }
    }


  }
  patchRepeatFieldValue(field: any, values: any, key: any, i: any) {

    if (field.templateOptions.label) {
      field.templateOptions.label = this.translate.instant(field?.templateOptions?.label);
    }
    let dateField = field.key + "FormattedDate"
    if (field.type == 'view-upload-file') {
      field.templateOptions.files = [];
      let uploadedFiles: any[] = values[key][i][field.key]?.attachmentID;
      if (uploadedFiles?.length > 0) {
        uploadedFiles.forEach(file => {
          field.templateOptions.files.push({
            "fileName": file.fileName,
            "href": file.uploadedURL
          })
        })
      }
      field.defaultValue = values[key][i][field.key];
    }
    else if (values[dateField]) {
      // let value = field.key.replace("MDID", "");
      field.defaultValue = values[key][i][dateField] ? values[key][i][dateField] : "-";
    }
    else if (field.key.trim().includes("MDID") && !Array.isArray(values[key][i][field.key])) {
      let value = field.key.replace(/(MDID)\b$/, '');
      field.defaultValue = values[key][i][value] ? values[key][i][value] : "-";
    }
    else if (field.key.trim().includes("ID") && !Array.isArray(values[key][i][field.key])) {
      let value = field.key.replace(/(ID)\b$/, '');
      field.defaultValue = values[key][i][value] ? values[key][i][value] : "-";
    }
    else if (field.key.trim().includes("id") && !Array.isArray(values[key][i][field.key])) {
      let value = field.key.replace(/(id)\b$/, '');
      field.defaultValue = values[key][i][value] ? values[key][i][value] : "-";
    }
    else if (field.templateOptions?.isAmount) {
      // const key = field.key;
      const value = values[key][i][field.key];
      // Check if the value in the model is a valid number
      if (!isNaN(Number(value)) && values[key][i][field.key] != null) {
        // Format the number based on the user's locale
        const formattedAmount = new Intl.NumberFormat(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(parseFloat(value));
        field.defaultValue = formattedAmount ? formattedAmount : "-"
      }
    }
    else if (Array.isArray(values[key][i][field.key]) && values[key][i][field.key]?.length > 0) {
      let concatenatedText = values[key][i][field.key]?.map(item => item.text).join(", ");
      field.defaultValue = concatenatedText ? concatenatedText : "-";
    }

    
    else {
      if (typeof values[key][i][field.key] === 'boolean') {
        field.defaultValue = values[key][i][field.key] ? 'Yes' : 'No';
      } else {
        field.defaultValue = values[key][i][field.key] != null ? values[key][i][field.key] : '-';
      }

    }

  }
  patchGridFieldValue(field: any, values: any, key: any, i: any, model: any) {
    if (field.templateOptions.label) {
      field.templateOptions.label = this.translate.instant(field?.templateOptions?.label);
    }
    let dateField = field.key + "FormattedDate"
 
    if (values[dateField]) {
      // let value = field.key.replace("MDID", "");
      field.defaultValue = values[key][i][dateField] ? values[key][i][dateField] : "-";
      model[key][i][field.key] = values[key][i][dateField] ? values[key][i][dateField] : "-";
    }
    else if (field.key.trim().includes("MDID") && !Array.isArray(values[key][i][field.key])) {
      let value = field.key.replace(/(MDID)\b$/, '');
      field.defaultValue = values[key][i][value] ? values[key][i][value] : "-";
      model[key][i][field.key] = values[key][i][value] ? values[key][i][value] : "-";

    }
    else if (field.key.trim().includes("ID") && !Array.isArray(values[key][i][field.key])) {
      let value = field.key.replace(/(ID)\b$/, '');
      field.defaultValue = values[key][i][value] ? values[key][i][value] : "-";
      model[key][i][field.key] = values[key][i][value] ? values[key][i][value] : "-";

    }
    else if (field.key.trim().includes("id") && !Array.isArray(values[key][i][field.key])) {
      let value = field.key.replace(/(id)\b$/, '');
      field.defaultValue = values[key][i][value] ? values[key][i][value] : "-";
      model[key][i][field.key] = values[key][i][value] ? values[key][i][value] : "-";
    }
    else if (field.templateOptions?.isAmount) {
      // const key = field.key;
      const value = values[key][i][field.key];
      // Check if the value in the model is a valid number
      if (!isNaN(Number(value)) && values[key][i][field.key] != null) {
        // Format the number based on the user's locale
        const formattedAmount = new Intl.NumberFormat(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(parseFloat(value));
        field.defaultValue = formattedAmount ? formattedAmount : "-"
        model[key][i][field.key] = formattedAmount ? formattedAmount : "-"
      }
    }
    else if (Array.isArray(values[key][i][field.key]) && values[key][i][field.key]?.length > 0) {
      let concatenatedText = values[key][i][field.key]?.map(item => item.text).join(", ");
      field.defaultValue = concatenatedText ? concatenatedText : "-";
      model[key][i][field.key] = concatenatedText ? concatenatedText : "-";
    }


    else {
      if (typeof values[key][i][field.key] === 'boolean') {
        field.defaultValue = values[key][i][field.key] ? 'Yes' : 'No';
        model[key][i][field.key] = values[key][i][field.key] ? 'Yes' : 'No';
      } else {
        field.defaultValue = values[key][i][field.key] != null ? values[key][i][field.key] : '-';
        model[key][i][field.key] = values[key][i][field.key] != null ? values[key][i][field.key] : '-';
      }

    }

  }
  // Method to patch individual field values
  patchFieldValue(field: any, values: any) {
    field.templateOptions.label = this.translate.instant(field?.templateOptions?.label);
    let dateField = field.key + "FormattedDate"
    if (field.type == 'view-upload-file') {
      field.templateOptions.files = [];
      let uploadedFiles: any[] = values[field.key]?.attachmentID;
      if (uploadedFiles?.length > 0) {
        uploadedFiles.forEach(file => {
          field.templateOptions.files.push({
            "fileName": file.fileName,
            "href": file.uploadedURL
          })
        })
      }
      field.defaultValue = values[field.key];
    }
    else if (values[dateField]) {
      // let value = field.key.replace("MDID", "");
      field.defaultValue = values[dateField] ? values[dateField] : "-";
    }
    else if (field.key.trim().includes("MDID") && !Array.isArray(values[field.key])) {
      let value = field.key.replace(/(MDID)\b$/, '');
      field.defaultValue = value ? values[value] : "-";
    }
    else if (Array.isArray(values[field.key]) && values[field.key].length > 0 && field.key != 'availabilityJson') {

      let concatenatedText = values[field.key]?.map(item => item.text).join(", ");
      field.defaultValue = concatenatedText ? concatenatedText : "-";
    }
    else if (field.key.trim().includes("ID") && !Array.isArray(values[field.key])) {
      let value = field.key.replace(/(ID)\b$/, '');
      field.defaultValue = values[value] ? values[value] : "-";
    }
    else if (field.key.trim().includes("id") && !Array.isArray(values[field.key])) {
      let value = field.key.replace(/(id)\b$/, '');
      field.defaultValue = values[value] ? values[value] : "-";
    }
    else if (field.templateOptions?.isAmount) {
      // const key = field.key;
      const value = values[field.key];
      // Check if the value in the model is a valid number
      if (!isNaN(Number(value)) && values[field.key] != null) {
        // Format the number based on the user's locale
        const formattedAmount = new Intl.NumberFormat(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(parseFloat(value));
        field.defaultValue = formattedAmount ? formattedAmount : "-"
      }
      else {
        field.defaultValue = values[value] ? values[value] : "-";
      }
    }

    else if (field.key == 'availabilityJson') {
      field.defaultValue = values[field.key]
    }
    else {
      if (typeof values[field.key] === 'boolean') {
        field.defaultValue = values[field.key] ? 'Yes' : 'No';
      } else {
        field.defaultValue = values[field.key] != null ? values[field.key] : '-';
      }

    }


  }
  scrollToFirstInvalidField(form) {
    const invalidFields = this.findInvalidControls(form);
    // console.log('invalid', invalidFields)
    if (invalidFields.length > 0) {
      const invalidElement = document.querySelector(`[id="${invalidFields[0]}"]`);
      if (invalidElement) {
        invalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // invalidElement.focus();
      }
    }
  }
  findInvalidControls(formGroup: FormGroup): string[] {
    const invalidControls = [];
    const controls = formGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalidControls.push(name);
      }
    }
    return invalidControls;
  }


  markAllFieldsAsTouched(form: FormGroup | FormArray) {
    if (form instanceof FormGroup) {
      Object.keys(form.controls).forEach(key => {
        const control = form.get(key);

        if (control instanceof FormGroup || control instanceof FormArray) {
          // Recursively mark controls inside FormGroup or FormArray
          this.markAllFieldsAsTouched(control);
        } else {
          this.loader.hide();
          control.markAsTouched();
          control.markAsDirty();
          control.updateValueAndValidity();
        }
      });
    } else if (form instanceof FormArray) {
      form.controls.forEach((arrayControl) => {
        if (arrayControl instanceof FormGroup || arrayControl instanceof FormArray) {
          // Recursively mark controls inside FormArray or FormGroup
          this.markAllFieldsAsTouched(arrayControl);
        } else {
          this.loader.hide();
          arrayControl.markAsTouched();
          arrayControl.markAsDirty();
          arrayControl.updateValueAndValidity();
        }
      });
    }
  }

  markFieldsAsTouched(form: any) {

    Object.keys(form.controls).forEach(key => {
      const control: any = form.get(key);

      if (control && (control.value === null || control.value === undefined)) {
        control.setValue(null); // Set value to 0 if the value is null
        control.markAsTouched();
        control.markAsDirty();
        form.controls[key].updateValueAndValidity();
      }
      if (control && control.value === null && (control.defaultValue === null || control.defaultValue === undefined)) {
        control.markAsDirty();
        control.markAsTouched();
        control.defaultValue === null; // Set value to 0 if the value is null
        // form.controls[key].updateValueAndValidity();
      }
   
    });

  }
}
